import { FirestorePath, InboundEmail, Org } from "..";
import { DomainVerification } from "../models/DomainVerification";
import { Group } from "../models/Group";
import { Mailbox } from "../models/Mailbox";
import { Member } from "../models/Member";
import { OutboundEmail } from "../models/OutboundEmail";
import { Owner } from "../models/Owner";
import { TrashEmail } from "../models/TrashEmail";
import { DraftEmail } from "../models/DraftEmail";
import { UserProfile } from "../models/UserProfile";
import { EmailKey, GroupKey, MailboxKey, MemberKey, OrgKey, OwnerKey, UserKey } from "../models/base/Keys";

const userProfiles = new FirestorePath<{}, void>(`user_profiles`);
const userProfile = new FirestorePath<UserKey, UserProfile>(`${userProfiles.template}/{uid}`);

const orgs = new FirestorePath<{}, void>(`orgs`);
const org = new FirestorePath<OrgKey, Org>(`${orgs.template}/{orgId}`);

const owners = new FirestorePath<OrgKey, Owner>(`${org.template}/owners`);
const owner = new FirestorePath<OwnerKey, Owner>(`${owners.template}/{uid}`);

const ownersCollectionGroup = new FirestorePath<{}, Owner>(`owners`);
const membersCollectionGroup = new FirestorePath<{}, Member>(`members`);

const members = new FirestorePath<OrgKey, Member>(`${org.template}/members`);
const member = new FirestorePath<MemberKey, Member>(`${members.template}/{uid}`);

const groups = new FirestorePath<OrgKey, Group>(`${org.template}/groups`);
const group = new FirestorePath<GroupKey, Group>(`${groups.template}/{groupId}`);

const domainVerifications = new FirestorePath<{}, DomainVerification>(`domain_verifications`);
const domainVerification = new FirestorePath<OrgKey, DomainVerification>(`${domainVerifications.template}/{orgId}`);

const mailboxes = new FirestorePath<OrgKey, Mailbox>(`${org.template}/mailboxes`);
const mailbox = new FirestorePath<MailboxKey, Mailbox>(`${mailboxes.template}/{uid}`);
//use emailkey instead

const inbox = new FirestorePath<MailboxKey, InboundEmail>(`${mailbox.template}/inbox`);
const inboundEmail = new FirestorePath<EmailKey, InboundEmail>(`${inbox.template}/{emailId}`);

const outbox = new FirestorePath<MailboxKey, OutboundEmail>(`${mailbox.template}/outbox`);
const outboundEmail = new FirestorePath<EmailKey, OutboundEmail>(`${outbox.template}/{emailId}`);

const drafts = new FirestorePath<MailboxKey, DraftEmail>(`${mailbox.template}/drafts`);
const draftEmail = new FirestorePath<EmailKey, DraftEmail>(`${drafts.template}/{emailId}`);

const trash = new FirestorePath<MailboxKey, TrashEmail>(`${mailbox.template}/trash`);
const trashEmail = new FirestorePath<EmailKey, TrashEmail>(`${trash.template}/{emailId}`);

const archive = new FirestorePath<MailboxKey, InboundEmail>(`${mailbox.template}/archive`);
const archiveEmail = new FirestorePath<EmailKey, InboundEmail>(`${archive.template}/{emailId}`);

export const firestorePaths = {
  userProfile,
  userProfiles,
  org,
  orgs,
  owners,
  owner,
  members,
  member,
  groups,
  group,
  domainVerifications,
  domainVerification,
  mailboxes,
  mailbox,
  drafts,
  inbox,
  outbox,
  trash,
  ownersCollectionGroup,
  membersCollectionGroup,
  inboundEmail,
  outboundEmail,
  archive,
  archiveEmail,
  draftEmail,
  trashEmail,
};
